import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button, ButtonProps } from "@/components/ui/button";
import CheckoutButton from "@/components/CheckoutButton";

interface EnrollButtonProps extends Omit<ButtonProps, "asChild"> {
  label?: string;
  wrapperClassName?: string;
}

/**
 * The general "enroll" call to action, for the places that serve signed-in and
 * signed-out visitors alike.
 *
 * A signed-in student already has somewhere to be, so they go to their
 * dashboard. Everybody else is here to buy, and buying happens on the external
 * checkout, which needs no account on this site.
 *
 * Note this is deliberately NOT used on /pricing: there the button must reach
 * the checkout even for a signed-in visitor, because a registered user who has
 * not bought yet is exactly the person that button is for.
 */
const EnrollButton = ({
  children,
  label = "Enroll Now",
  className = "",
  wrapperClassName = "",
  ...props
}: EnrollButtonProps) => {
  const { user } = useAuth();

  if (!user) {
    return (
      <CheckoutButton className={className} wrapperClassName={wrapperClassName} {...props}>
        {children ?? label}
      </CheckoutButton>
    );
  }

  return (
    <Link to="/dashboard" className={wrapperClassName}>
      <Button className={className} {...props}>
        {children ?? label}
      </Button>
    </Link>
  );
};

export default EnrollButton;
